import { render, staticRenderFns } from "./TwoUpdateForm.vue?vue&type=template&id=95c4e696"
import script from "./TwoUpdateForm.vue?vue&type=script&lang=js"
export * from "./TwoUpdateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports